import { CycleDivergence } from '@andywilliams/indicators';

// The stored divergence events (DWLF-338): one id set per oscillator, from the library. The one
// list the chart's fetch, the event catalogue and the recent-events lookback all read.
export const DIVERGENCE_EVENT_DEFINITIONS = Object.freeze([
  ...CycleDivergence.getRsiDivergenceEventDefinitions(),
  ...CycleDivergence.getDssDivergenceEventDefinitions(),
].map((definition) => Object.freeze({ ...definition })));
